import { getDocumentMetadataGroups } from './getDocumentMetadataGroups';
import { getProperties } from './properties';
export const getMetadataProperties = () => {
    const properties = getProperties();
    const groupedProperties = getDocumentMetadataGroups(properties);
    return {
        allProperties: properties,
        propertyGroups: groupedProperties,
    };
};
